function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { connect } from 'react-redux';
import { createStructuredSelector, createSelector } from 'reselect';
import { isItemBoxSpecialNotecard, isItemBoxSpecialCrinklePaper, isForbiddenToChangeQuantityPerBox, isBox, isItemBoxSpecialTape, isItemBoxAddon } from 'swag-common/utils/order/item-is-box.util';
import { showPopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { CART_BOX_BUILDER_POPUP } from 'swag-client-common/constants';
import { isItemSampleBox } from 'swag-common/utils/order/is-item-sample-box.util';
import { getFormattedProductNameFromItem } from 'swag-common/business-logic/inventory-product-name/get-modified-item-name-and-original.logic';
import { productionTimeListForItemSelector, isItemEditPossibleSelector, globalItemsInBoxesConflictMessagesSelector, standaloneItemsValidationsSelector, standaloneDraftItemsValidationsSelector, isViewColorsShownSelector, isSharedOrRelatedItemSelector, setupFeeLabelSelector, isRelatedItemSelector, isItemLimitedEditionSelector, isSuperSpeedItemSelector, filteredProductionTimeListForItemSelector, isEmbroideryEmbellishmentMethodSelectedForTooltipSelector } from '../../../../../customer/redux/cart/cart.selectors';
import { openRemoveDialog } from '../../../../../customer/redux/cart/cart.actions';
import { startEditBoxBuilderMode } from '../../../../../customer/redux/box-builder/box-builder.actions';
import { setEditingBoxNameBoxId } from '../../../../../customer/redux/box-builder/box-builder.actions';
import CartItem from './cart-item';
const propsSelector = (state, props) => props;
const validationErrorSelector = createSelector(propsSelector, globalItemsInBoxesConflictMessagesSelector, standaloneItemsValidationsSelector, standaloneDraftItemsValidationsSelector, ({
  item: {
    _id
  }
}, boxValidations, standaloneItemsValidations, standaloneDraftItemsValidations) => {
  var _standaloneDraftItems, _standaloneDraftItems2, _standaloneDraftItems3;
  return boxValidations[_id] || standaloneItemsValidations[_id] || ((_standaloneDraftItems = standaloneDraftItemsValidations[_id]) === null || _standaloneDraftItems === void 0 ? void 0 : _standaloneDraftItems.isOutOfStock) && standaloneDraftItemsValidations[_id] || ((_standaloneDraftItems2 = standaloneDraftItemsValidations[_id]) === null || _standaloneDraftItems2 === void 0 ? void 0 : _standaloneDraftItems2.isSomeItemPrintLocationRemoved) && standaloneDraftItemsValidations[_id] || ((_standaloneDraftItems3 = standaloneDraftItemsValidations[_id]) === null || _standaloneDraftItems3 === void 0 ? void 0 : _standaloneDraftItems3.isItemLogosEmpty) && standaloneDraftItemsValidations[_id];
});
const isOutOfStockSelector = createSelector(validationErrorSelector, validationError => validationError === null || validationError === void 0 ? void 0 : validationError.isOutOfStock);
const productNameSelector = createSelector(propsSelector, ({
  item
}) => getFormattedProductNameFromItem(item));
const isItemBoxSpecialTapeSelector = createSelector(propsSelector, ({
  item
}) => isItemBoxSpecialTape(item));
const isProductionTimeDisabledSelector = createSelector(propsSelector, isRelatedItemSelector, isOutOfStockSelector, ({
  item: {
    isCustomizedBlank,
    isPrintedSample,
    isSample
  }
}, isRelatedItem, isOutOfStock) => isSample || isRelatedItem || isPrintedSample || isCustomizedBlank || isOutOfStock);
const isSelectingProductionTimeDisabledSelector = createSelector(filteredProductionTimeListForItemSelector, isProductionTimeDisabledSelector, isSuperSpeedItemSelector, (productionTimeList, isProductionTimeDisabled, isSuperSpeedItem) => {
  return isProductionTimeDisabled || !isSuperSpeedItem && productionTimeList.length <= 1;
});
const shouldShowProductionTimeTooltipSelector = createSelector(filteredProductionTimeListForItemSelector, isSuperSpeedItemSelector, (productionTimeList, isSuperSpeedItem) => {
  return !isSuperSpeedItem && productionTimeList.length <= 1;
});
const isProductionTimeClickableSelector = createSelector(propsSelector, isOutOfStockSelector, filteredProductionTimeListForItemSelector, isSuperSpeedItemSelector, ({
  item: {
    isCustomizedBlank
  }
}, isOutOfStock, productionTimeList, isSuperSpeedItem) => {
  const hasProductionTimeListAppropriateLength = isSuperSpeedItem ? productionTimeList.length >= 1 : productionTimeList.length > 1;
  return !isCustomizedBlank && !isOutOfStock && hasProductionTimeListAppropriateLength;
});
const mapStateToProps = createStructuredSelector({
  productionTimeList: productionTimeListForItemSelector,
  isEditPossible: isItemEditPossibleSelector,
  boxValidations: globalItemsInBoxesConflictMessagesSelector,
  standaloneItemsValidations: standaloneItemsValidationsSelector,
  validationError: validationErrorSelector,
  isOutOfStock: isOutOfStockSelector,
  isSampleOutOfStock: createSelector(propsSelector, isOutOfStockSelector, ({
    item: {
      isSample,
      isPrintedSample
    }
  }, isOutOfStock) => (isSample || isPrintedSample) && isOutOfStock),
  isItemBoxSpecialCrinklePaper: createSelector(propsSelector, ({
    item
  }) => isItemBoxSpecialCrinklePaper(item)),
  isSharedOrRelatedItem: isSharedOrRelatedItemSelector,
  isSetupFeeTooltipShown: createSelector(propsSelector, isSharedOrRelatedItemSelector, isRelatedItemSelector, ({
    item,
    isBoxItem
  }, isSharedItem, isRelatedItem) => {
    const {
      setupFee
    } = item;
    const isBoxItself = isBox(item);
    return setupFee > 0 && !isBoxItself && (!isBoxItem || isSharedItem) && !isRelatedItem;
  }),
  isItemBoxSpecialNotecard: createSelector(propsSelector, ({
    item
  }) => isItemBoxSpecialNotecard(item)),
  isViewColorsShown: isViewColorsShownSelector,
  isSetupFeeShown: createSelector(propsSelector, ({
    item,
    item: {
      isSample,
      setupFee,
      isPrintedSample,
      isCustomizedBlank
    },
    isFullDesign
  }) => Number.isFinite(setupFee) && !isBox(item) && !isFullDesign && !isSample && !isPrintedSample && !isCustomizedBlank && !isItemBoxSpecialNotecard(item) && !isItemBoxSpecialCrinklePaper(item) && !isItemBoxSpecialTape(item)),
  isInfoTooltipShown: createSelector(propsSelector, _ref => {
    let {
        item: {
          customProductId,
          isReorder
        },
        isThisItemBox = false,
        isSuperSpeedAddonWarn
      } = _ref,
      rest = _objectWithoutProperties(_ref.item, ["customProductId", "isReorder"]);
    return isThisItemBox && !(customProductId && isReorder) || isSuperSpeedAddonWarn && isItemBoxAddon(rest);
  }),
  isSwagSampleBox: createSelector(propsSelector, ({
    item
  }) => isItemSampleBox(item)),
  isProdTimeInvalid: createSelector(propsSelector, productionTimeListForItemSelector, ({
    item: {
      prodTime
    }
  }, productionTimeList) => !productionTimeList[prodTime] && prodTime !== 0),
  isForbiddenToChangeQuantityPerBox: createSelector(propsSelector, ({
    item
  }) => isForbiddenToChangeQuantityPerBox(item)),
  isBoxItself: createSelector(propsSelector, ({
    item
  }) => isBox(item)),
  isEditNameAvailable: createSelector(propsSelector, ({
    item
  }) => isBox(item) && !(item.inventoryId && item.isReorder)),
  productName: productNameSelector,
  setupFeeLabel: setupFeeLabelSelector,
  isRelatedItem: isRelatedItemSelector,
  isItemBoxSpecialTape: isItemBoxSpecialTapeSelector,
  isLimitedEdition: isItemLimitedEditionSelector,
  isSuperSpeed: isSuperSpeedItemSelector,
  isSelectingProductionTimeDisabled: isSelectingProductionTimeDisabledSelector,
  shouldShowProductionTimeTooltip: shouldShowProductionTimeTooltipSelector,
  isProductionTimeClickable: isProductionTimeClickableSelector,
  isEmbroideryEmbellishmentMethod: isEmbroideryEmbellishmentMethodSelectedForTooltipSelector
});
const mapDispatchToProps = dispatch => ({
  onOpenRemoveDialog: (itemId, storageType) => {
    dispatch(openRemoveDialog(itemId, storageType));
  },
  onEditBoxNameClick: id => {
    dispatch(setEditingBoxNameBoxId(id));
    dispatch(showPopup({
      popup: CART_BOX_BUILDER_POPUP
    }));
  },
  onEditQuantityClick: itemId => {
    dispatch(startEditBoxBuilderMode(itemId));
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(CartItem);